import React from "react";
import { eventClick } from "../services/adobeDataLayer.js";

const STYLES = `
  .sxi_2d720440_main_container,
  .sxi_2d720440_main_container * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .sxi_2d720440_main_container {
    --sxi_2d720440_primary: #A31A13;
    --sxi_2d720440_accent: #E3530F;
    --sxi_2d720440_headline: #E3531F;
    /* navy + slate sampled from the source artwork; not defined in branding.json */
    --sxi_2d720440_navy: #16305F;
    --sxi_2d720440_slate: #333;
    --sxi_2d720440_muted: #333333;
    --sxi_2d720440_connector: #C9CFDC;
    --sxi_2d720440_card_border: #F4E7DA;
    --sxi_2d720440_radius_card: 16px;
    --sxi_2d720440_radius_pill: 50px;
    --sxi_2d720440_font: 'Mulish', sans-serif;
    --sxi_2d720440_gap: clamp(1.5rem, 3vw, 2.5rem);
    --sxi_2d720440_badge: 68px;

    position: relative;
    overflow: hidden;
    padding: clamp(3.5rem, 7vw, 5.5rem) 0 calc(clamp(3.5rem, 7vw, 5.5rem) + 10px);
    color: var(--sxi_2d720440_slate);
    -webkit-font-smoothing: antialiased;
  }

  .sxi_2d720440_main_container .sxi_2d720440_container {
    max-width: 74rem;
    margin-inline: auto;
    padding-inline: clamp(1.25rem, 4vw, 2rem);
  }

  .sxi_2d720440_main_container .sxi_2d720440_header {
    text-align: center;
  }

  .sxi_2d720440_main_container .sxi_2d720440_title {
    font-size: 28px;
    font-weight: 900;
    line-height: 35px;
    letter-spacing: -0.01em;
    text-wrap: balance;
    text-align: left;
  }

  @media screen and (max-width: 767px) {
    .sxi_2d720440_main_container .sxi_2d720440_title {
      font-size: 25px;
      line-height: 35px;
      text-align: left;
    }

    .sxi_2d720440_main_container .sxi_2d720440_step_copy {
      font-size: 14px;
      line-height: normal;
    }

    .sxi_2d720440_main_container .sxi_2d720440_lead {
      text-align: left;
    }
  }

  .sxi_2d720440_main_container .sxi_2d720440_title_top {
    display: block;
    color: var(--sxi_2d720440_headline);
  }

  .sxi_2d720440_main_container .sxi_2d720440_title_brand {
    display: block;
    color: var(--sxi_2d720440_headline);
  }

  @media screen and (min-width: 768px) {
    .sxi_2d720440_main_container .sxi_2d720440_title {
      white-space: nowrap;
    }

    .sxi_2d720440_main_container .sxi_2d720440_title_top,
    .sxi_2d720440_main_container .sxi_2d720440_title_brand {
      display: inline;
    }

    .sxi_2d720440_main_container .sxi_2d720440_lead {
      text-align: left;
      margin-top: 0.75rem;
    }
  }

  .sxi_2d720440_main_container .sxi_2d720440_lead {
    font-size: clamp(1.0625rem, 0.95rem + 0.6vw, 1.25rem);
    color: var(--sxi_2d720440_muted);
  }

  .sxi_2d720440_main_container .sxi_2d720440_steps_grid {
    list-style: none;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: var(--sxi_2d720440_gap);
    margin-top: clamp(3rem, 6vw, 4.25rem);
  }

  .sxi_2d720440_main_container .sxi_2d720440_step {
    position: relative;
    display: flex;
    flex-direction: column;
    padding-top: calc(var(--sxi_2d720440_badge) / 2);
  }

  .sxi_2d720440_main_container .sxi_2d720440_step_num {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    width: var(--sxi_2d720440_badge);
    height: var(--sxi_2d720440_badge);
    display: grid;
    place-items: center;
    background: var(--sxi_2d720440_accent);
    color: #FFFFFF;
    font-size: 1.375rem;
    font-weight: 800;
    letter-spacing: 0.02em;
    border: 4px solid #FFFFFF;
    border-radius: 50%;
    box-shadow: 0 8px 18px rgba(163, 26, 19, 0.24);
  }

  .sxi_2d720440_main_container .sxi_2d720440_step:not(:first-child)::before {
    content: "";
    position: absolute;
    top: 30px;
    right: calc(50% + 46px);
    width: calc(100% + var(--sxi_2d720440_gap) - 92px);
    border-top: 3px dotted var(--sxi_2d720440_connector);
  }

  .sxi_2d720440_main_container .sxi_2d720440_step_card {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background: #FFFFFF;
    border: 1px solid var(--sxi_2d720440_card_border);
    border-radius: var(--sxi_2d720440_radius_card);
    padding: 3.25rem 1.75rem 2.25rem;
    box-shadow: 0 18px 40px -18px rgba(163, 26, 19, 0.18), 0 4px 14px rgba(22, 48, 95, 0.05);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
  }

  @media (hover: hover) {
    .sxi_2d720440_main_container .sxi_2d720440_step_card:hover {
      transform: translateY(-5px);
      box-shadow: 0 26px 48px -18px rgba(163, 26, 19, 0.26), 0 6px 18px rgba(22, 48, 95, 0.07);
    }
  }

  .sxi_2d720440_main_container .sxi_2d720440_step_icon {
    width: 64px;
    height: 64px;
    color: var(--sxi_2d720440_accent);
    margin-bottom: 1.25rem;
  }

  .sxi_2d720440_main_container .sxi_2d720440_step_icon svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  .sxi_2d720440_main_container .sxi_2d720440_step_heading {
    color: var(--sxi_2d720440_accent);
    font-size: 1.3125rem;
    font-weight: 800;
    line-height: 1.3;
    text-wrap: balance;
  }

  .sxi_2d720440_main_container .sxi_2d720440_step_heading::after {
    content: "";
    display: block;
    width: 44px;
    height: 3px;
    border-radius: 999px;
    background: var(--sxi_2d720440_accent);
    margin: 0.875rem auto 0;
  }

  .sxi_2d720440_main_container .sxi_2d720440_step_copy {
    color: var(--sxi_2d720440_muted);
    margin-top: 1rem;
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
  }

  .sxi_2d720440_main_container .sxi_2d720440_step_copy:not(:last-child) { margin-bottom: 1.75rem; }

  .sxi_2d720440_main_container .sxi_2d720440_step_cta {
    margin-top: auto;
    display: inline-flex;
    align-items: center;
    gap: 0.625rem;
    padding: 1rem 2rem;
    background: var(--sxi_2d720440_accent);
    color: #FFFFFF;
    font-size: 1.0625rem;
    font-weight: 700;
    line-height: 1;
    text-decoration: none;
    border-radius: var(--sxi_2d720440_radius_pill);
    transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  }

  .sxi_2d720440_main_container .sxi_2d720440_step_cta svg {
    width: 1.125em;
    height: 1.125em;
    transition: transform 0.2s ease;
  }

  .sxi_2d720440_main_container .sxi_2d720440_step_cta:hover {
    background: var(--sxi_2d720440_primary);
    box-shadow: 0 10px 22px -8px rgba(163, 26, 19, 0.5);
  }

  .sxi_2d720440_main_container .sxi_2d720440_step_cta:hover svg { transform: translateX(3px); }

  .sxi_2d720440_main_container .sxi_2d720440_step_cta:active { transform: translateY(1px); }

  .sxi_2d720440_main_container .sxi_2d720440_step_cta:focus-visible {
    outline: 3px solid rgba(227, 83, 15, 0.5);
    outline-offset: 3px;
  }

  @media (max-width: 991.98px) {
    .sxi_2d720440_main_container .sxi_2d720440_steps_grid {
      grid-template-columns: 1fr;
      max-width: 30rem;
      margin-inline: auto;
      row-gap: 3.5rem;
    }

    .sxi_2d720440_main_container .sxi_2d720440_step:not(:first-child)::before {
      top: -3rem;
      right: auto;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2.5rem;
      border-top: none;
      border-left: 3px dotted var(--sxi_2d720440_connector);
    }
  }

  @media (max-width: 420px) {
    .sxi_2d720440_main_container .sxi_2d720440_step_card { padding-inline: 1.25rem; }
  }

  @media (prefers-reduced-motion: reduce) {
    .sxi_2d720440_main_container .sxi_2d720440_step_card,
    .sxi_2d720440_main_container .sxi_2d720440_step_cta,
    .sxi_2d720440_main_container .sxi_2d720440_step_cta svg { transition: none; }

    .sxi_2d720440_main_container .sxi_2d720440_step_card:hover { transform: none; }
  }
`;

const DetailsIcon = () => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
  >
    <rect x="13" y="7" width="33" height="44" rx="5" />
    <path d="M21 17h17M21 25h17M21 33h9" />
    <circle cx="42.5" cy="44.5" r="11.5" fill="#fff" />
    <circle cx="42.5" cy="41" r="3.6" />
    <path d="M35.8 51c1.3-3.6 3.8-5.4 6.7-5.4s5.4 1.8 6.7 5.4" />
  </svg>
);

const HeadsetIcon = () => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
  >
    <path d="M13 36v-7c0-10.5 8.5-19 19-19s19 8.5 19 19v7" />
    <rect x="9" y="34" width="11" height="17" rx="5.5" />
    <rect x="44" y="34" width="11" height="17" rx="5.5" />
    <path d="M49.5 51v1.5c0 4-3.2 7.2-7.2 7.2h-6" />
    <circle cx="34" cy="59.7" r="2.6" fill="currentColor" stroke="none" />
  </svg>
);

const ClipboardCheckIcon = () => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
  >
    <rect x="13" y="10" width="33" height="43" rx="5" />
    <rect x="23.5" y="5" width="12" height="9" rx="3" fill="#fff" />
    <path d="M21 23h17M21 31h17M21 39h9" />
    <circle cx="42.5" cy="45.5" r="11" fill="#fff" />
    <path d="M37.5 45.6l3.4 3.4 6.4-6.6" />
  </svg>
);

const ArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M4 12h15m-6-7 7 7-7 7" />
  </svg>
);

const STEPS = [
  {
    number: "01",
    Icon: DetailsIcon,
    heading: "Submit your details",
    copy: "Fill in your basic details such as your Name, PAN, Mobile Number, Employer Name, PIN Code, and other required information.",
    ctaLabel: "Go to the Form",
  },
  {
    number: "02",
    Icon: HeadsetIcon,
    heading: "Get contacted by Relationship Manager",
    copy: "Based on your eligibility, an ICICI Bank Relationship Manager will contact you on your submitted mobile number.",
  },
  {
    number: "03",
    Icon: ClipboardCheckIcon,
    heading: "Complete the account opening process",
    copy: "Relationship Manager will meet you, verify your details, and assist you with the remaining formalities to open your ICICI Bank Salary Account.",
  },
];

export default function HowToOpenSalaryAccount({ onCtaClick }) {
  const handleCtaClick = (event) => {
    event.preventDefault();

    if (onCtaClick) {
      onCtaClick(event);
      return;
    }

    eventClick("go to the form", "link", "how-to-open-salary-account");
    window.dispatchEvent(new CustomEvent("adobeCTAClick"));

    const formElement = document.getElementById("myForm");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        const firstNameField = document.getElementById("firstName");
        if (firstNameField) {
          firstNameField.focus();
        }
      }, 300);
    }
  };

  return (
    <section className="sxi_2d720440_main_container">
      <style>{STYLES}</style>

      <div className="sxi_2d720440_container">
        <div className="sxi_2d720440_header">
          <h2 className="sxi_2d720440_title" id="sxi_2d720440_steps_title">
            <span className="sxi_2d720440_title_top">How to Open an</span>{" "}
            <span className="sxi_2d720440_title_brand">ICICI Bank Salary Account</span>
          </h2>
          <p className="sxi_2d720440_lead">Open your account in three simple steps.</p>
        </div>

        <ol className="sxi_2d720440_steps_grid">
          {STEPS.map(({ number, Icon, heading, copy, ctaLabel }) => (
            <li className="sxi_2d720440_step" key={number}>
              <span className="sxi_2d720440_step_num" aria-hidden="true">
                {number}
              </span>
              <div className="sxi_2d720440_step_card">
                <span className="sxi_2d720440_step_icon" aria-hidden="true">
                  <Icon />
                </span>
                <h3 className="sxi_2d720440_step_heading">{heading}</h3>
                <p className="sxi_2d720440_step_copy">{copy}</p>
                {ctaLabel && (
                  <a
                    className="sxi_2d720440_step_cta"
                    href="#myForm"
                    onClick={handleCtaClick}
                  >
                    {ctaLabel}
                    <ArrowIcon />
                  </a>
                )}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
